import type { IconSvgObject } from './types';

const Heading01Icon: IconSvgObject = [
  ["path", { d: "M17 19H18.5M20 19H18.5M18.5 19V11H18L17 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 12H13M4 19V5M13 19V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Heading01Icon;
